import { GeographicalDistributionApplicant } from "./geographical-applicant";
export default GeographicalDistributionApplicant;
